import script from "./CallNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./CallNotifications.vue?vue&type=script&setup=true&lang=js"

import "./CallNotifications.vue?vue&type=style&index=0&id=72125c8e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72125c8e"]])

export default __exports__